import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'fgbcl-loading',
  templateUrl: 'loading.component.html',
})
export class LoadingComponent implements OnInit {
  @Input() size: 'small' | 'medium' = 'medium';
  @Input() color: string | null = null;
  style: { [key: string]: string } = {};

  ngOnInit() {
    if (this.color) {
      this.style['color'] = this.color;
    }
  }
}
